
export default function FullScreenLoader({ message = 'Loading...' }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-700/40 backdrop-blur-[1px]">
      <div className="relative flex flex-col items-center gap-5">
        <div className="relative h-16 w-16">
          <div className="absolute inset-0 rounded-full border-4 border-indigo-200 animate-[spin_2.5s_linear_infinite]"></div>
          <div className="absolute inset-0 rounded-full border-4 border-t-indigo-600 border-r-transparent border-b-transparent border-l-transparent animate-[spin_1.2s_linear_infinite]"></div>
        </div>
        {/* <p className="text-base font-medium text-gray-800 dark:text-gray-200 tracking-wide">
          {message}
        </p> */}
      </div>
    </div>
  );
}